import { store, getContext, withSyncEvent } from '@wordpress/interactivity';

store( 'install-plugin', {
	state: {
		get installUrl() {
			const context = getContext();
			return context.url + '/wp-admin/plugin-install.php?s=' + encodeURIComponent( context.search ).replace( /%20/g, '+' ) + '&tab=search&type=term';
		},

	},
	actions: {
		generate: ( e ) => {
			const context = getContext();
			if ( e ) {
				context.url = e.target.value;
			}
			if ( ! context.url ) {
				context.url = 'https://example.com';
			}
			if ( context.url.substr( 0, 8 ) !== 'https://' ) {
				context.url = 'https://' + context.url;
			}
		},
		openLink: ( event ) => {
			if ( event.target.href.includes( 'example.com' ) ) {
				const context = getContext();
				context.url = prompt( 'Please enter the URL of your WordPress site:', '' );
				if ( ! context.url ) {
					context.url = 'https://example.com';
					event.preventDefault();
					return;
				}
				if ( context.url.substr( 0, 8 ) !== 'https://' ) {
					context.url = 'https://' + context.url;
				}

			}
		},
	}
} );
